import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * Keeps the installments amount in sync with the selected variant.
 *
 * Mirrors the contract used by product-inventory.js: the variant update event
 * carries the re-rendered document, so the amount is always the server's, never
 * recalculated in the browser.
 */
class InstallmentsNotice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateNotice);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateNotice);
  }

  /**
   * Replaces the contents with the markup rendered for the new variant.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateNotice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newNotice = event.detail.data.html.querySelector('installments-notice');

    if (!newNotice) return;

    morph(this, newNotice, { childrenOnly: true });
  };
}

if (!customElements.get('installments-notice')) {
  customElements.define('installments-notice', InstallmentsNotice);
}
